import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import MobileBottomBar from './MobileBottomBar';

/**
 * Persistent layout for all public-facing routes.
 * Navbar, MobileBottomBar and Footer mount ONCE for the entire session and
 * remain stable as child routes change underneath via <Outlet />.
 */
const PublicLayout = () => {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
      {/* Spacer so the mobile sticky bar never overlaps the bottom of the footer */}
      <div className="md:hidden h-14" aria-hidden="true" />
      <MobileBottomBar />
    </>
  );
};

export default PublicLayout;
